import { render, staticRenderFns } from "./Motivation2025.vue?vue&type=template&id=8050a4b2&scoped=true&"
import script from "./Motivation2025.vue?vue&type=script&lang=js&"
export * from "./Motivation2025.vue?vue&type=script&lang=js&"
import style0 from "./Motivation2025.vue?vue&type=style&index=0&id=8050a4b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8050a4b2",
  null
  
)

export default component.exports